module.exports = __webpack_public_path__ + "static/img/invite_friends.bc1882d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/invite_friends.png
// module id = YT01
// module chunks = 1